import { useEffect, useState } from 'react';
import { injectUserSession, IStateUserSession, IStateUserSessionManager } from '../../interface/state';
import { activeSession } from '../../controllers/downloadrequest/util';
import ILanguageDto from '@workspace/apiservice/src/model/LanguageDto.if';

const useUserSession = () => {
    const [userState, setUserState] = useState<{ state: IStateUserSession | null; session: IStateUserSessionManager | null }>({ state: null, session: null })
    const [language, setLanguage] = useState<ILanguageDto | null>(null)

    useEffect(() => {
        const loadSession = async () => {
            const session = await injectUserSession();
            const state = await session.current();
            setUserState({ session, state })
        }
        loadSession()
    }, []);

    useEffect(() => {
        const getLanguage = async () => {
            const session = await activeSession(injectUserSession());
            if ( !session || !userState.state ) { return; }
            const language = await session.db.language().get(userState.state.languageId)
            language.code && setLanguage({ ...language, code: language.code.toLowerCase() })
        }
        if(userState) {
            getLanguage()
        }
    }, [userState]);

    return { userState, language }
}

export default useUserSession